import { devtools } from "zustand/middleware";
import { create } from "zustand";

export type NotificationType = "success" | "error";

export interface Notification {
  id: number;
  message: string;
  type: NotificationType;
}

interface NotificationState {
  notifications: Notification[];
  addNotification: (message: string, type: NotificationType) => void;
  removeNotification: (id: number) => void;
}

export const useNotificationStore = create<NotificationState>()(
  devtools(
    (set, get) => ({
      notifications: [],
      addNotification: (message, type) => {
        const id = new Date().getTime();
        set((state) => ({
          notifications: [{ id, message, type }],
        }));
        setTimeout(() => {
          get().removeNotification(id);
        }, 3000);
      },
      removeNotification: (id) =>
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id),
        })),
    }),
    {
      name: "notification-storage",
    }
  )
);
